import { useEffect, useRef } from 'react'
import styles from './Downloads.module.scss'
import useHubSpotGenerate from 'hooks/useHubSpotGenerate'
import LeftContents from './LeftContents'
import { LeftContentDataType } from './types/types'
import { gsap, Power4 } from 'gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'
import MailmagazineLink from 'components/mailmagazine/MailmagazineLink/MailmagazineLink'

gsap.registerPlugin(ScrollTrigger)

const leftContentData: LeftContentDataType = {
  titleVol: <>プロダクト開発成功のカギ</>,
  alt: 'プロダクト開発成功のカギ',
  readText: <>プロダクトマネジメントのトレンドであるPdM（プロダクトマネージャー）とPMM（プロダクトマーケティングマネージャー）の分業について、全17ページで解説</>,
  imgLarge: '/images/img/download/pmmchecklist/thumbnail_pmm.webp',
  imgCapture: '/images/img/download/pmmchecklist/capture_pmm.webp',
  firstContentTitle: 'このような方におすすめ',
  firstHalf: (
    <>
      この資料では、売上拡大のために大手外資系IT企業が導入しているPMMについて解説してます。組織間の連携が円滑に進まず課題を抱えている方や、売上拡大のためのグロース戦略について詳しく知りたい方におすすめの資料です。
    </>
  ),
  secondContentTitle: 'この資料でわかること',
  secondHalf1: 'GAFAなどの大手外資系IT企業で標準化が進んでいるPdM（プロダクトマネージャー）とPMM（プロダクトマーケティングマネージャー）の分業の仕組みについて',
  secondHalf2: 'PMMがプロジェクトを推進する具体的な進め方と、導入が適切かを判断するためのチェックリスト',
  secondHalf3: '',
}

const DownloadPmmChecklist: React.FC = () => {
  const title_category = useRef<HTMLSpanElement>(null)
  const title_page = useRef<HTMLSpanElement>(null)
  useHubSpotGenerate('na1', '9395227', '014ba3da-299b-4788-a6bd-f13367c982d3', '#hbspt')
  useEffect(() => {
    gsap.set([title_category.current, title_page.current, `.${styles.read_text}`, `.${styles.section}`], { opacity: 0, y: 50 });

    const timeline = gsap.timeline({
      defaults: {
        opacity: 0,
        y: 50,
        duration: 1,
        ease: Power4.easeOut,
      },
    });

    const commonTo = { opacity: 1, y: 0 };

    timeline
      .to(title_category.current, commonTo, 0.2)
      .to(title_page.current, commonTo, 0.5)
      .to(`.${styles.read_text}`, commonTo, 0.8)
      .to(`.${styles.section}`, commonTo, 1.1);
  }, [])

  return (
    <article className={`${styles.main} downloadArea`}>
      <section className={styles.contents}>
        <h1 className={styles.ttl}>
          <span ref={title_category}>Download</span>
          <span ref={title_page}>{leftContentData.titleVol}</span>
        </h1>
        <p className={styles.read_text}>{leftContentData.readText}</p>
        <section className={styles.section}>
          <LeftContents
            leftContentData={leftContentData}
            isSecondContent={true}
          />
          <div className={styles.content}>
            <div className={styles.title_group}>
              <p className={styles.whitepaper}>
                ご入力いただいたメールアドレス宛に、資料ダウンロード用URLを送付いたします。
              </p>
              <p className={styles.notice}>※ 全ての項目をご入力ください。</p>
            </div>
            <div id="hbspt"></div>
          </div>
        </section>
      </section>
      <MailmagazineLink />
    </article>
  )
}

export default DownloadPmmChecklist
